/*
 * Mobile product-card titles: shrink the font so every title fits on ONE line
 * (instead of wrapping and misaligning neighboring cards). Applies below
 * 768px; resets to the theme's font size above it. Handles dynamically
 * injected cards (carousels, quick view, filtering) via MutationObserver.
 */
(function () {
  var MOBILE_MAX = 767;
  var MIN_FONT_PX = 10;
  var SAFETY = 0.98;

  function fit(el) {
    el.style.fontSize = '';
    if (window.innerWidth > MOBILE_MAX) {
      el.classList.remove('title-fitted');
      return;
    }
    el.classList.add('title-fitted'); /* applies white-space: nowrap */
    if (!el.clientWidth || !el.scrollWidth) return;
    if (el.scrollWidth > el.clientWidth) {
      var base = parseFloat(getComputedStyle(el).fontSize);
      var size = Math.max(MIN_FONT_PX, base * (el.clientWidth / el.scrollWidth) * SAFETY);
      el.style.fontSize = size + 'px';
    }
  }

  function fitAll(root) {
    (root || document).querySelectorAll('.product-card-title').forEach(fit);
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(function () { fitAll(); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fitAll(); });
  } else {
    fitAll();
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1 &&
            (added[j].matches && added[j].matches('.product-card-title') ||
             added[j].querySelector && added[j].querySelector('.product-card-title'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
